var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"formModal"},[_c('v-card',{staticClass:"px-10 py-5 d-flex justify-start align-center formModal__content"},[_vm._t("form")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }